import React, { useState, useEffect } from "react";
import { Space } from 'antd';
import { CloseOutlined } from "@ant-design/icons";
import AppIconButton from "@nxsys/components/AppIconButton"
import AppButton from "@nxsys/components/AppButton"
import { StyledDrawer } from "./index.styled";

type AppDrawerContainerProps = {
  isOpen: boolean;
  title: string | React.ReactNode;
  /** Pixels, or any CSS width such as '70vw'. */
  width?: number | string;
  placement?: "top" | "right" | "bottom" | "left";
  actions?: {
    name: string;
    icon?: React.ReactNode;
    variant?: "text" | "outlined" | "dashed" | "link" | "solid" | "filled";
    buttonType?: "link" | "default" | "primary" | "dashed" | "text" | undefined;
    onClick: () => void;
  }[];
  toggle: () => void;
  children: React.ReactNode;
  /** Class on the drawer root (it renders outside the page), for feature-scoped styles. */
  rootClassName?: string;
  /** For a drawer that opens over another one (antd stacks equal z-indexes by DOM order). */
  zIndex?: number;
};

const AppDrawerContainer: React.FC<AppDrawerContainerProps> = ({
  title,
  isOpen,
  toggle,
  width = 560,
  placement = "right",
  actions,
  children,
  rootClassName,
  zIndex,
}: AppDrawerContainerProps) => {
    const [open, setOpen] = useState(false);
    useEffect(() => {
      setOpen(isOpen);
    }, [isOpen]);

    const onClose = () => {
      setOpen(false);
      toggle();
    };
  return (
    <StyledDrawer
      open={open}
      rootClassName={rootClassName}
      zIndex={zIndex}
      title={title}
      width={width}
      placement={placement}
      closable={false}
      onClose={onClose}
      extra={
        <AppIconButton
          icon={
            <CloseOutlined />
          }
          onClick={onClose}
        />
      }
      footer={
        <Space>
          {actions?.map((action, index) => (
            <AppButton
              key={index}
              icon={action?.icon}
              name={action.name}
              variant={action.variant}
              type={action.buttonType || "primary"}
              onClick={action.onClick}
            />
          ))}
        </Space>
      }
    >
      {children}
    </StyledDrawer>
  );
}
export default AppDrawerContainer;
